import request from 'app/api/request';
import { useQuery, UseQueryResult } from 'react-query';
import { CoverageResponse } from './coverage-types';

export const coverageQueryKeys = {
  coverageByDocument: 'COVERAGE_BY_DOCUMENT',
} as const;

export function useCoverage(documentSuperId: number | string | undefined, enabled: boolean): UseQueryResult<CoverageResponse | null> {
  return useQuery(
    [coverageQueryKeys.coverageByDocument, documentSuperId],
    async () => {
      const res = await request.get(`/gaby/coverage/document/${documentSuperId}`).catch((err: { status: number }) => {
        if (err.status === 404) return null;
        throw err;
      });
      return (res?.data as CoverageResponse) || null;
    },
    { enabled: enabled && documentSuperId !== undefined, staleTime: 0 }
  );
}
